export default "__VITE_ASSET__CzXRyhi6__"